"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.StorageCleanupManager = void 0;
var _logging = require("../logging"),
  _constants = require("./constants");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var StorageCleanupManager = /*#__PURE__*/function () {
  function StorageCleanupManager(a, b) {
    _classCallCheck(this, StorageCleanupManager);
    _defineProperty(this, "cleanupInterval", void 0), _defineProperty(this, "externalStorage", void 0), this.externalStorage = a, this.cleanupInterval = b, 0 < b && this.initCleanupInterval();
  }
  return _createClass(StorageCleanupManager, [{
    key: "initCleanupInterval",
    value: function initCleanupInterval() {
      var _this = this;
      var _loop = function _loop() {
        var a = _Object$values[_i];
        var b = null;
        try {
          switch (a) {
            case _constants.KameleoonStorageKey.ForcedFeatureVariation:
            case _constants.KameleoonStorageKey.ForcedExperimentVariation:
            case _constants.KameleoonStorageKey.VariationData:
            case _constants.KameleoonStorageKey.ConsentData:
              _logging.KameleoonLogger.info(_templateObject || (_templateObject = _taggedTemplateLiteral(["Starting cleanup for ", " with interval ", ""])), a, _this.cleanupInterval), b = setInterval(function () {
                return _this.cleanupData(a);
              }, _this.cleanupInterval);
              break;
            case _constants.KameleoonStorageKey.ClientData:
            case _constants.KameleoonStorageKey.TargetingData:
            case _constants.KameleoonStorageKey.TrackingData:
            case _constants.KameleoonStorageKey.VisitorCode:
            case _constants.KameleoonStorageKey.DataInfo:
            case _constants.KameleoonStorageKey.KameleoonSimulationFFData:
              break;
            default:
              _logging.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Unknown storage key: ", " for initCleanupInterval."])), a);
          }
        } catch (c) {
          b && clearInterval(b), _logging.KameleoonLogger.error(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Error while starting cleanup for ", " with interval ", ""])), a, _this.cleanupInterval);
        }
      };
      for (var _i = 0, _Object$values = Object.values(_constants.KameleoonStorageKey); _i < _Object$values.length; _i++) {
        _loop();
      }
    }
  }, {
    key: "cleanupData",
    value: function cleanupData(a) {
      var b = this.externalStorage.read(a);
      if (b) {
        var c = Date.now();
        switch (a) {
          case _constants.KameleoonStorageKey.VariationData:
            this.cleanupVariationData(b, c);
            break;
          case _constants.KameleoonStorageKey.ForcedFeatureVariation:
            this.cleanupForcedFeatureVariationData(b, c);
            break;
          case _constants.KameleoonStorageKey.ForcedExperimentVariation:
            this.cleanupForcedExperimentVariationData(b, c);
            break;
          case _constants.KameleoonStorageKey.ConsentData:
            this.cleanupConsentData(b, c);
            break;
          case _constants.KameleoonStorageKey.ClientData:
          case _constants.KameleoonStorageKey.TargetingData:
          case _constants.KameleoonStorageKey.TrackingData:
          case _constants.KameleoonStorageKey.VisitorCode:
          case _constants.KameleoonStorageKey.DataInfo:
          case _constants.KameleoonStorageKey.KameleoonSimulationFFData:
            break;
          default:
            _logging.KameleoonLogger.error(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["Unknown storage key: ", " for cleanupData."])), a);
        }
        this.externalStorage.write(a, b);
      }
    }
  }, {
    key: "cleanupConsentData",
    value: function cleanupConsentData(a, b) {
      for (var _i2 = 0, _Object$entries = Object.entries(a); _i2 < _Object$entries.length; _i2++) {
        var _ref = _Object$entries[_i2];
        var _ref2 = _slicedToArray(_ref, 2);
        var c = _ref2[0];
        var d = _ref2[1];
        if ("boolean" == typeof d) {
          a[c] = {
            consent: d,
            expirationTime: b + this.cleanupInterval
          };
          continue;
        }
        var e = d;
        "number" == typeof e.expirationTime ? e.expirationTime < b && delete a[c] : e.expirationTime = b + this.cleanupInterval;
      }
    }
  }, {
    key: "cleanupVariationData",
    value: function cleanupVariationData(a, b) {
      for (var _i3 = 0, _Object$entries2 = Object.entries(a); _i3 < _Object$entries2.length; _i3++) {
        var _ref3 = _Object$entries2[_i3];
        var _ref4 = _slicedToArray(_ref3, 2);
        var c = _ref4[0];
        var d = _ref4[1];
        this.cleanupObjectValues(d, b), 0 === Object.keys(a[c]).length && delete a[c];
      }
    }
  }, {
    key: "cleanupForcedFeatureVariationData",
    value: function cleanupForcedFeatureVariationData(a, b) {
      for (var _i4 = 0, _Object$entries3 = Object.entries(a); _i4 < _Object$entries3.length; _i4++) {
        var _ref5 = _Object$entries3[_i4];
        var _ref6 = _slicedToArray(_ref5, 2);
        var c = _ref6[0];
        var d = _ref6[1];
        for (var _i5 = 0, _Object$entries4 = Object.entries(d); _i5 < _Object$entries4.length; _i5++) {
          var _ref7 = _Object$entries4[_i5];
          var _ref8 = _slicedToArray(_ref7, 2);
          var e = _ref8[0];
          var f = _ref8[1];
          this.cleanupObjectValues(f, b), 0 === Object.keys(a[+c][e]).length && delete a[+c][e];
        }
      }
    }
  }, {
    key: "cleanupForcedExperimentVariationData",
    value: function cleanupForcedExperimentVariationData(a, b) {
      for (var _i6 = 0, _Object$entries5 = Object.entries(a); _i6 < _Object$entries5.length; _i6++) {
        var _ref9 = _Object$entries5[_i6];
        var _ref10 = _slicedToArray(_ref9, 2);
        var c = _ref10[0];
        var d = _ref10[1];
        this.cleanupObjectValues(d, b), 0 === Object.keys(a[c]).length && delete a[c];
      }
    }
  }, {
    key: "cleanupObjectValues",
    value: function cleanupObjectValues(a, b) {
      for (var _i7 = 0, _Object$entries6 = Object.entries(a); _i7 < _Object$entries6.length; _i7++) {
        var _ref11 = _Object$entries6[_i7];
        var _ref12 = _slicedToArray(_ref11, 2);
        var c = _ref12[0];
        var d = _ref12[1];
        "number" == typeof d.expirationTime ? d.expirationTime < b && delete a[c] : d.expirationTime = b + this.cleanupInterval;
      }
    }
  }]);
}();
exports.StorageCleanupManager = StorageCleanupManager;